import { OpaccCompareButton, OpaccCompareSelect } from './classes/opacc.class.compare.js';

export const opaccCompareButtonPlugin = new OpaccCompareButton();
export const opaccCompareSelectPlugin = new OpaccCompareSelect();